import { type ReactNode, useState } from 'react';

import InlineValueEditor from '@app/components/InlineValueEditor';

type InlineValueEditorProps = {
    value: string;
    placeholder?: string;

    areaLabel: string;
    submitAreaLabel?: string;
    cancelAreaLabel?: string;
    editAreaLabel?: string;

    required?: boolean;
    readonly?: boolean;
    submitOnBlur?: boolean;
    loading?: boolean;

    displayValue?: string | ReactNode;

    onEditStart?: () => void;
    onEditCanceled?: () => void;
    onEditSubmitted?: (newValue: string, oldValue: string) => void;
    responseHandler?: (stagedValue: string) => void;
};

const StyleGuideInlineValueEditor = ({ required, ...props }: InlineValueEditorProps) => {
    const [error, setError] = useState<string | false>(false);
    const [open, setOpen] = useState(false);

    const onEditStart = () => {
        props.onEditStart?.();
        setOpen(true);
        setError(false);
    };

    const onEditCanceled = () => {
        props.onEditCanceled?.();
        setOpen(false);
        setError(false);
    };

    const onEditSubmitted = (newValue: string, oldValue: string) => {
        if (required && !newValue) {
            setError('This field is required');

            return;
        }

        setError('');
        props.onEditSubmitted?.(newValue, oldValue);
        setOpen(false);
    };

    return (
        <InlineValueEditor
            {...props}
            error={error}
            placeholder="Name"
            editAreaLabel="Edit name"
            cancelAreaLabel="Cancel"
            submitAreaLabel="Submit"
            onEditStart={onEditStart}
            onEditCanceled={onEditCanceled}
            onEditSubmitted={onEditSubmitted}
            open={open}
        />
    );
};

export default StyleGuideInlineValueEditor;
